export default __webpack_public_path__ + "static/aws-training-and-certification-a4e7f9cb05fb0037b9a04fdca7af1402.png";